import { useEffect } from 'react';
import { addBreadcrumb } from '@sentry/react';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { useMembership } from '@ocx/data-membership';
import { logInDev } from '@ocx/utils';

import { useReferralReceiverStatusModal } from './hooks';

export const ReferralStatusController = () => {
  const { membership } = useMembership();
  const { showStatusModalIfNeeded } = useReferralReceiverStatusModal();
  useEffect(() => {
    const timer = setTimeout(() => {
      showStatusModalIfNeeded({
        id: membership.id,
        createdAt: membership.createdAt,
        incomingReferralStatus: membership.incomingReferralStatus,
      }).catch((e) => {
        addBreadcrumb({
          message: 'HomeController > showStatusModalIfNeeded threw an exception.',
          data: e,
        });
        logInDev(e);
      });
    }, 700);
    return () => {
      clearTimeout(timer);
    };
  }, [membership.createdAt, membership.id, membership.incomingReferralStatus, showStatusModalIfNeeded]);
  return null;
};
